import React, { useMemo } from "react"
import { useLocation, useHistory } from "react-router"
import { FetchRecommandedListingsComponent } from "src/generated/graphql"
import Text, { H2Text } from "src/components/text/text.component"
import theme from "src/theme/"
import styled from "styled-components"
import SkeletonLoading from "src/components/skeleton-loading"
import {
  ListingItems,
  ListingItem,
  ListingItemImage,
  StyledLink,
  Heading3,
  SeeMoreListings,
  SeeMoreListingsContent,
  SeeMoreListingsOverlay
} from "src/containers/home/UI"
import { DEFAULT_SPACE_PICTURE } from "../../config/constants"
import MultiCarousel from "src/components/carousel"
import { fCurrency } from "src/utils/format-number"

export const RecommendedContainer = styled.div<any>`
  width:100%;
  max-width:1300px
  margin:4% auto;
  padding-inline: 2rem;
  @media (max-width: 900px) {
    margin:0;
    padding-inline:${({ padding }) => (padding ? padding : "15px")};
}
  }
`
const RecommendedListing = ({ isTabletOrMobile }: { isTabletOrMobile: boolean }) => {
  const params: any = useLocation()
  const history = useHistory()

  const blogId = useMemo(() => {
    const searchQuery = params?.pathname?.split("/")[2]
    return searchQuery
  }, [params?.search])

  return (
    <RecommendedContainer>
      <H2Text color={theme.colors.black} fontWeight={600} fontSize={[4, 5, 5]}>
        Recommended listings
      </H2Text>

      <ListingItems justifyContent="center">
        <FetchRecommandedListingsComponent
          variables={{
            where: {
              id: blogId
            }
          }}
        >
          {({ loading, data, error }) => {
            if (loading)
              return [...Array(isTabletOrMobile ? 1 : 4)].map(() => (
                <SkeletonLoading
                  rows={1}
                  imgHeight={"100px"}
                  width={isTabletOrMobile ? "100%" : "18rem"}
                  isImage
                />
              ))
            if (error) {
              console.log({ fetchTrendingListingsError: error })
            }
            if (!data || !data.recommendListings || data.recommendListings.length < 1) {
              return <p>No Listings</p>
            }
            let recommendedData: any = data?.recommendListings
            const isExistSeeMore = recommendedData?.some(item => item.id === "see more")
            if (!isExistSeeMore) {
              recommendedData.push({
                id: "see more",
                pictures: [],
                title: "see more",
                units: [],
                __typename: "see more listing"
              })
            }

            return (
              <MultiCarousel infinite={false}>
                {recommendedData.map((listing, index) => {
                  if (!listing) return null
                  if (index == recommendedData?.length - 1) {
                    return (
                      <ListingItem width={["100%"]} key={`moar`} marginBottom={0}>
                        <SeeMoreListings
                          onClick={() =>
                            history.push({
                              pathname: "/search"
                            })
                          }
                          width={"100%"}
                          maxWidth={"100%"}
                          src="/images/lofts-4.jpg"
                        >
                          <SeeMoreListingsContent width={["100%"]}>
                            <Text color={theme.colors.white} fontSize={[2, 3, 3]}>
                              See more listings
                            </Text>
                            <Text
                              style={{
                                width: "100%"
                              }}
                              color={theme.colors.white}
                              fontSize={[1, 2, 2]}
                            >
                              We’ve made it easy to find your perfect place
                            </Text>
                          </SeeMoreListingsContent>
                          <SeeMoreListingsOverlay width={["100%"]} />
                        </SeeMoreListings>
                      </ListingItem>
                    )
                  } else {
                    return (
                      <>
                        <ListingItem
                          width={["100%"]}
                          key={`recommended-listing-${index}`}
                          marginBottom={0}
                        >
                          <StyledLink href={`/listing/${listing.id}`}>
                            <ListingItemImage
                              src={
                                (listing.pictures &&
                                  listing.pictures[0] &&
                                  listing.pictures[0].url) ||
                                ""
                              }
                              placeholder={DEFAULT_SPACE_PICTURE}
                              transition="all 1s linear"
                            />


                            <Text
                              color={theme.colors.primary}
                              fontSize={[2, 2, 2]}
                              fontWeight={10}
                              mt={3}
                            >
                              {listing.units &&
                                listing.units[0] &&
                                listing.units[0].monthlyPrice ? `${fCurrency(listing.units[0].monthlyPrice)}/Month` : 'Contact For Pricing!'}
                            </Text>
                            <Heading3>{listing.title}</Heading3>
                          </StyledLink>
                        </ListingItem>
                      </>
                    )
                  }
                })}
              </MultiCarousel>
            )
          }}
        </FetchRecommandedListingsComponent>
      </ListingItems>
    </RecommendedContainer>
  )
}
export default RecommendedListing
